import React, { useState } from 'react';
import { MainLayout } from '@design-system/Layout';
import { BasketContainer, Container } from './style';
import Cart from './components/cart';
import Summary from './components/summary';
import { useEffect } from 'react';
// import { useHistory } from 'react-router-dom';
import BasketSvg from '@design-system/Assets/no-basket.png';
import { Button } from '@design-system/Button';
import { Link } from 'react-router-dom';
import { Modal } from '@design-system/Modal';
import ModalContent from './components/modal';
import {
  add_product,
  delete_product_from_basket,
  get_logged_in_cart,
  update_basket_quantity,
} from './redux/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { getCreating, getLoggedInCart } from './redux/selectors';
import {
  get_cart,
  remove_item_from_cart,
  update_product_quantity,
} from '@app/product/redux/reducer';
import { getCart } from '@app/product/redux/selectors';

const Basket = () => {
  const [total, setTotal] = useState(0);
  const token = localStorage.getItem('x-access-token');
  const [show, setShow] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));
  const dispatch = useDispatch();
  const loading = useSelector(getCreating);
  const cart = useSelector(getCart);
  const basketItems = useSelector(getLoggedInCart);
  const partner = localStorage.getItem('partner_id');
  const [cartItems, setCartItems] = useState([]);
  const basket = localStorage.getItem('basket_id');

  useEffect(() => {
    dispatch(get_cart());
  }, [dispatch]);

  useEffect(() => {
    if (token) {
      setCartItems(basketItems);
    } else {
      setCartItems(cart);
    }
  }, [cart, basketItems, token]);

  useEffect(() => {
    if (partner) {
      dispatch(get_logged_in_cart(partner));
    }
  }, [dispatch, partner]);

  useEffect(() => {
    if (token) {
      const total = cartItems?.reduce((prev, curr) => {
        return prev + curr?.price?.value;
      }, 0);
      setTotal(total);
    } else {
      const total = cartItems?.reduce((prev, curr) => {
        return prev + curr?.price?.value * curr.quantity;
      }, 0);
      setTotal(total);
    }
  }, [cartItems, token]);

  const removeItem = (doc) => {
    if (token) {
      dispatch(delete_product_from_basket(doc));
    } else {
      dispatch(remove_item_from_cart(doc));
    }
  };

  const updateQuantity = (indx, newQuantity) => {
    if (token) {
      dispatch(update_basket_quantity({ id: indx, data: newQuantity }));
    } else {
      dispatch(update_product_quantity({ indx, newQuantity }));
    }
  };

  useEffect(() => {
    if (token && cart?.length >= 1) {
      const products = cart?.map((data) => {
        return {
          product: data._id,
          quantity: data.quantity,
          size: data.size,
        };
      });
      let doc = {
        partner: cart[0]?.partner,
        products: products,
        user: user._id,
      };
      dispatch(add_product(doc));
    }
  }, [token, cart]);

  const handleNavigate = () => {
    if (token === null) {
      setShow(true);
    } else {
      window.location.href = `/shipping/${basket}`;
    }
  };
  return (
    <MainLayout>
      <Modal show={show} close={() => setShow(!show)}>
        <ModalContent />
      </Modal>
      <Container>
        {cartItems?.length <= 0 || !cartItems ? (
          <div className="empty">
            <img src={BasketSvg} alt="svg" />
            <h4>Your basket is empty!</h4>
            <Link to="/marketplace" style={{ textDecoration: 'none' }}>
              <Button text="Start Shopping" bgColor="#549A9A" />
            </Link>
          </div>
        ) : (
          <BasketContainer>
            <div className="shopping_basket">
              <div className="cart_body">
                {cartItems &&
                  cartItems?.map((doc) => (
                    <Cart
                      cart={doc}
                      key={doc._id}
                      onClick={() => removeItem(doc.product_id || doc._id)}
                      updateQuantitys={updateQuantity}
                    />
                  ))}
              </div>
            </div>

            <div className="summary">
              <div className="header">Basket Summary</div>
              <Summary
                total={total}
                handleNavigate={handleNavigate}
                loading={loading}
              />
            </div>
          </BasketContainer>
        )}
      </Container>
    </MainLayout>
  );
};

export default Basket;
